module.exports = __webpack_public_path__ + "img/lcl-front-profile.8f11e2c0.svg";